module.exports = __webpack_public_path__ + "img/poster3.1d0efdce.png";